/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: toolbar-component.js
 *
 * Created by randysorensen on 2/16/17.
 */

'use strict';

function ToolbarController (_, UtilsService) {

	var self = this;


	//=================//
	// Lifecycle Hooks //
	//=================//

	self.$onInit = function () {
		if (self.buttonDefs === undefined) {
			self.buttonDefs = [];
		}

		if (self.rightHandCheckboxDefs === undefined) {
			self.rightHandCheckboxDefs = [];
		}
	};

    // Our local copy of the button defs, which can be further
    // processed (e.g. have default icons assigned)
    var processedButtonDefs = null;
    var processedRightHandCheckboxDefs = null;

	self.$onChanges = function (changes) {
        if (_.has(changes, 'buttonDefs')) {
            processedButtonDefs = null;
            if (self.buttonDefs === undefined) {
                self.buttonDefs = [];
            }
        }
        if (_.has(changes, 'rightHandCheckboxDefs')) {
            processedRightHandCheckboxDefs = null;
            if (self.rightHandCheckboxDefs === undefined) {
                self.rightHandCheckboxDefs = [];
            }
        }
    };


	//=================//
	// Toolbar Buttons //
	//=================//

	// Default Font Awesome icons to use for buttons with
	// particular names
	var defaultIcons = {
		clone: 'fa-files-o',
		close: 'fa-times',
		delete: 'fa-times',
		edit: 'fa-wrench',
		new: 'fa-plus',
		hide: 'fa-eye-slash',
		revert: 'fa-undo',
		save: 'fa-floppy-o',
		unhide: 'fa-eye',
        refresh: 'fa-refresh'
	};

	var processButtonDefs = function () {
		var order = 0;

		processedButtonDefs = _.cloneDeep(self.buttonDefs);
		processedButtonDefs.forEach(function (buttonDef) {
			// assign default icon if none included
			if (buttonDef.icon === undefined) {
				buttonDef.icon = defaultIcons[buttonDef.label.toLowerCase()] !== undefined ?
					defaultIcons[buttonDef.label.toLowerCase()] :
					'fa-question';
			}
            buttonDef.hasIconStack = (typeof(buttonDef.icon) !== 'string');

			// assign button order; utilize included order, if any
			if (buttonDef.order >= order) {
				order = buttonDef.order + 1;
			} else if (buttonDef.order === undefined) {
				buttonDef.order = order;
				++order;
			}
		});
	};

	self.getButtons = function () {
		if (processedButtonDefs === null) {
			processButtonDefs(self.buttonDefs);
		}
		return processedButtonDefs;
	};


	//============//
	// Pagination //
	//============//

	self.paginationSupported = function () {
		return self.paginationDefs;
	};


	//===============================//
	// Dynamic Right-Hand Checkboxes //
	//===============================//

	var checkboxToggledFunc = function (cbDef) {
		// call owner's onUpdate() function
		cbDef.onUpdate(cbDef.isChecked);
	};

	var processCheckboxDefs = function (checkboxDefs) {
		var processedCheckboxDefs = _.clone(checkboxDefs);
		var order = 0;
		processedCheckboxDefs.forEach(function (cbDef) {
			cbDef.toggled = checkboxToggledFunc;
			cbDef.order = order++;
			cbDef.id = UtilsService.firstToLowerCase(
				UtilsService.removeSpaces(
					cbDef.label
			)) + 'Checkbox';
		});

		return processedCheckboxDefs;
	};

	self.getRightHandCheckboxes = function () {
		if (processedRightHandCheckboxDefs === null) {
			processedRightHandCheckboxDefs = processCheckboxDefs(self.rightHandCheckboxDefs);
		}
		return processedRightHandCheckboxDefs;
	};
}

angular
.module('prism-ui.components')
.component('toolbar', {
	bindings: {
		/*
		buttonDefs - an array of objects, each defining a toolbar
		button.

		Each button object consists of the following properties:

		 	label:		(string; required) The button label. Also
		 				used to find default icon (see 'icon' &
		 				'defaultIcons' var above).

		 	enabled:	(function; required) Function returning
		 				boolean to indicate whether the button is
		 				enabled.

			onClick:	(function; required) Click handler
						function.

			icon:		(string | string[]; optional) Font Awesome
			            icon name (e.g. 'fa-plus'). If a default
			            exists for the label you provide, this may
			            be omitted.
						If multiple Font Awesome icon names are
						specified, all the icons will be stacked
						on-top of each other.

			order:		(integer; optional) The order in which the
						button should appear on the toolbar. If
						omitted, the order of appearance in the
						array will be used.
		*/
		buttonDefs: '<',
		paginationDefs: '<',

		/*
		rightHandCheckboxDefs - a dynamic array of checkbox
		objects, each representing a checkbox to place on the
		right-hand side of the toolbar.

		The first checkbox in the list will be the right-most.
		Subsequent checkboxes will proceed in order to the left.

		Each checkbox object consist of the following properties:

			label:		(string; required) The checkbox's label.

			onUpdate:	(function; required) A function that will
			 			be called when the checkbox's state
			 			changes, being passed the new state. E.g.
			 			onUpdate(false).

			isChecked:  (boolean; optional) The checkbox's initial
			 			checked state.
		*/
		rightHandCheckboxDefs: '<',
	},
	controller: ToolbarController,
	templateUrl: 'components/visual/toolbar/toolbar-template.html',
});
